import { Box, OldHeading, Link } from '@gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type Props = {}

const ErrorState: FC<Props> = () => {
  const { t } = useTranslation('other')
  return (
    <Box>
      <OldHeading variant="h3" as="h3" mb=".5rem">
        {t('errorPageTitle')}
      </OldHeading>
      <Link as="button" onClick={() => window.location.reload()}>
        {t('tryAgain')}
      </Link>
    </Box>
  )
}

export default ErrorState
